<template>
  <div class="d-flex flex-column" ref="container">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="services"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :date="date"
    />

    <div class="container-fluid" ref="header">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Обслуживание</h1>
        <img class="mr-auto" src="~img/service-legend.svg" style="max-width: 900px; width: 100%; margin-bottom: -3px;">
        <button class="btn btn-primary mr-2" v-if="isAllowedToSave" @click="save()">Сохранить</button>
        <el-date-picker
          class="mr-2"
          v-model="date"
          type="daterange"
          :clearable="false"
          value-format="yyyy-MM-dd"
          align="right"
          range-separator="–"
          :picker-options="pickerOptions"
          size="small"
        />
        <btn-filters
          :data="data"
          endpoint="services"
          v-model="filtersValue"
        />
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        @load-more="$refs.data.loadMore"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
      >
        <table-column-serial-number sortable="keyword" :fixed="true"/>
        <el-table-column prop="address" label="Адрес установки" width="220"/>
        <el-table-column prop="services_planned" label="Плановые сервисы" min-width="1100">
          <template slot-scope="{row}">
            <machine-service-timeline
              :operator="row.operator"
              :tech="row.technician"
              :planned_prop="row.services_planned"
              :performed_prop="row.services_performed"
              :machine_id="row.id"
              :region_id="row.region_id"
              :date="date"
            />
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'
  import { get } from 'lodash'
  import api from '@/api'

  function monthRange (offset = 0) {
    return [
      moment().subtract(offset, 'month').startOf('month').format('YYYY-MM-DD'),
      moment().subtract(offset, 'month').endOf('month').format('YYYY-MM-DD'),
    ]
  }

  function pickerOptionHandler (offset = 0) {
    return (picker) => {
      picker.$emit('pick', monthRange(offset))
    }
  }

  export default {
    metaInfo: {title: 'Обслуживание'},
    data () {
      return {
        filtersValue: null,
        data: null,
        loading: false,
        hasMore: true,
        sort: null,
        date: monthRange(),
        pickerOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Следующий месяц',
            onClick: pickerOptionHandler(-1),
          }, {
            text: 'Текущий месяц',
            onClick: pickerOptionHandler(0),
          }, {
            text: 'Предыдущий месяц',
            onClick: pickerOptionHandler(1),
          }, {
            text: '2 месяца назад',
            onClick: pickerOptionHandler(2),
          }, {
            text: '3 месяца назад',
            onClick: pickerOptionHandler(3),
          }],
        },
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const sortable = sort.column.sortable

          // set prop name
          let prop = (sortable === 'keyword') ? sort.prop + '.keyword' : sort.prop

          this.sort = `${prop}:${order}`
        } else {
          this.sort = null
        }
      },
      save () {
        return api.post('services/schedule', {
          filters: this.filtersValue,
        })
      }
    },
    computed: {
      isAllowedToSave () {
        return ['service', 'tech_superior', 'service_superior'].includes(get(this.$root.user, 'role.name'))
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/service.vue